<script lang="ts" setup>
import SpatiumWhiteLogo from '@/Components/Shared/Logos/SpatiumWhiteLogo.vue'
import UserMenu from '@/Layouts/App/Components/Desktop/UserMenu.vue'
import NotificationsView from '@/Layouts/App/Components/Desktop/NotificationsView.vue'
import MainMenu from '@/Layouts/App/Components/Desktop/MainMenu.vue'
import Search from '@/Layouts/App/Components/Search.vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import { PopoverButton } from '@headlessui/vue'
import Teams from '@/Layouts/App/Components/Teams.vue'
import DarkModeMenu from '@/Layouts/App/Components/Desktop/DarkModeMenu.vue'
import { useAppLayout } from '@/stores/appLayout'
import IMBadgeStandAlone from '@/Layouts/App/Components/Desktop/IMBadgeStandAlone.vue'

defineProps({
  open: Boolean,
})

const { openCommandPalette } = useAppLayout()
</script>

<template>
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
    <div
      class="relative flex flex-wrap items-center justify-center lg:justify-between"
    >
      <!-- Logo -->
      <div class="absolute left-0 py-5 shrink-0 lg:static">
        <InertiaLink href="/home">
          <span class="sr-only">{{ __('Spatium') }}</span>
          <SpatiumWhiteLogo class="h-8 w-8 -ml-1 sm:m-0 sm:w-36" />
        </InertiaLink>
      </div>

      <!-- Right section on desktop -->
      <div class="hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5">
        <Teams />
        <DarkModeMenu />
        <NotificationsView />
        <IMBadgeStandAlone class="h-7 w-7" />
        <UserMenu />
      </div>

      <div class="w-full py-5 lg:border-t lg:border-white/20">
        <div class="lg:grid lg:grid-cols-3 lg:gap-8 lg:items-center">
          <!-- Left nav -->
          <MainMenu />
          <a class="px-12 lg:px-0 cursor-pointer" @click="openCommandPalette()">
            <!-- Search -->
            <Search class="px-4 sm:px-0" />
          </a>
        </div>
      </div>

      <!-- Menu button -->
      <div class="absolute right-0 shrink-0 lg:hidden">
        <!-- Mobile menu button -->
        <PopoverButton
          class="bg-transparent p-2 rounded-md inline-flex items-center justify-center text-neutral-200 hover:text-white hover:bg-white/10 focus:outline-hidden focus:ring-2 focus:ring-white"
        >
          <span class="sr-only">{{ __('Open main menu') }}</span>
          <Bars3Icon v-if="!open" aria-hidden="true" class="block h-6 w-6" />
          <XMarkIcon v-else aria-hidden="true" class="block h-6 w-6" />
        </PopoverButton>
      </div>
    </div>
  </div>
</template>
